import { Splide } from "@splidejs/splide";

/**
 * Object containing methods related to the card slider.
 */
const imgNavSlider = {
    _slider: null,
    _navItems: [],

    /**
     * Initializes the card slider.
     */
    init: function() {
        let self = this;
        let sliderNode = document.querySelector('.js-img-nav-slider');
        
        if (!sliderNode) return;
        
        window.initPackage('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js').then(function() {
            self._construct(sliderNode);
        })
        .catch(function(error) {
            console.error(error);
        });
    },

    /**
     * Creates a new Splide slider instance for each `.js-card-slider` element.
     */

    _construct(sliderNode) {
        let self = this;
        self._navItems = document.querySelectorAll('.js-img-nav-slider-nav');

        self._slider = new Splide(sliderNode, {
                type: 'loop',
                speed: 800,
                focus: 'center',
                accessibility: true,
                arrows: false,
                keyboard: true,
                autoplay: true,
                pagination: false,
                clones: 0,
                breakpoints: {
                    992: {
                        padding: '48px',
                        focus: 'center',
                        gap: '24px',
                        pagination: true,
                        clones: 1,
                    },

                    576: {
                        padding: '24px',
                        focus: 'center',
                        gap: '12px',
                        pagination: true,
                        clones: 1,
                    },
                    
                }
            }   
        );

        self._slider.on('ready', function() {
            self._calcHeight();
        });

        self._slider.on('move', function() {
            self._changeActiveNode(self._navItems[self._slider.index]);
        });

        self._slider.mount();
        self._imageNavigation();    
        self._updateOnWindowResize();
    
    },

    _imageNavigation() {
        let self = this;
        let navNodes = document.querySelectorAll('.js-img-nav-slider-nav');

        navNodes.forEach((navItem, index) => {
            navItem.addEventListener('click', (event) => {
                self._goToSlide(self, index, navItem);
            });
        });
    },

    _goToSlide(self, index, navItem) {
        self._slider.go(index);
    },

    _calcHeight() {
        let self = this;
        
        let sliderWrapper = document.querySelector('.js-img-nav-slider-wrapper');
        sliderWrapper.parentElement.querySelector('.js-img-nav-slider-nav-wrapper').style.height = sliderWrapper.offsetWidth / 16 * 9 + "px";
    },

    _updateOnWindowResize() {
        let self = this;

        function debounce(func, wait, immediate) {
            let timeout;
            return function() {
                let context = this, args = arguments;
                let later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };

        let onResizeUpdateHeight = debounce(function() {
            if(window.innerWidth > 992) {
                self._calcHeight();
            }
        }, 250);
        
        window.addEventListener('resize', onResizeUpdateHeight);
    },

    _changeActiveNode(navItem) {
        let self = this;
        navItem.parentElement.querySelector('.active').classList.remove('active');
        navItem.classList.add('active');
    },

    /**
     * Destroys all Splide slider instances and re-initializes the card slider.
     */
    reInit() {
        let self = this;
        
        if (self._slider) {
            self._slider.destroy();
        }

        self.init();
    },

        /**
         * Destroys all Splide slider instances.
         */
    _destroy() {
       let self = this;
        console.log(self._listenersRef);

    },
};


window.imgNavSlider = imgNavSlider;

window.imgNavSlider.init();

document.addEventListener('LokiRequestEnd', function () {
    window.imgNavSlider.reInit();
});